import { IPayPeriod } from "@/Common/api/types/CommissionCycle";

export const resolveSelectedPositionsDefault = (
	commissionCycleId: string,
	payPeriod?: IPayPeriod,
	partnerPayPeriod?: IPayPeriod | null
) => {
	if (!partnerPayPeriod) {
		return { [commissionCycleId]: [] as string[] };
	}
	return {
		[payPeriod?.previousCCId || payPeriod?.nextCCId || ""]: [],
		[partnerPayPeriod?.previousCCId || partnerPayPeriod?.nextCCId || ""]: [],
	};
};
